import { type ReactElement, type ReactNode } from 'react';
import { useKeystoneSession } from './use-keystone-session';

import { hasRole, type AppRole } from './roles';

export type RequireRoleProps = {
	required: AppRole | Array<AppRole>;
	fallback?: ReactNode;
	children: ReactNode;
};

// Reads roles directly from the Keystone JWT, NOT from Redux currentUser.
// This keeps route guards immune to the dev role-switcher (which mutates Redux for UI testing).
export const RequireRole = (props: RequireRoleProps): ReactElement => {
	const { required, fallback = null, children } = props;
	const { user } = useKeystoneSession();
	const jwtRoles = user?.appRoles ?? [];
	const ok = hasRole(jwtRoles, required);
	return ok ? <>{children}</> : <>{fallback}</>;
};
